import React from 'react';
import PropTypes from 'prop-types';
import InputWithChips from '../InputWithChips';
import Drawer from '../Drawer';
import ClientSearchModalNew from '../ClientSearchModalNew';
import ClientListItemGeneral from '../ClientListItemGeneral';

const ClientListInput = ({ history, customers, onChange, name, InputProps, hideDeleteChipButton }) => {
  const [isClientsSearchOpen, setIsClientsSearchOpen] = React.useState(false);

  const [selectedCustomers, setSelectedCustomers] = React.useState(customers);
  const inputRef = React.useRef();
  const handleOnInputOpen = () => {
    inputRef.current.blur();
    if (!InputProps?.readOnly) {
      setIsClientsSearchOpen(true);
    }
  };

  const handleOnDeleteChips = (chip) => {
    if (!InputProps?.readOnly) {
      const selectedCustomersTmp = { ...selectedCustomers };

      delete selectedCustomersTmp[chip.profileId];
      setSelectedCustomers(selectedCustomersTmp);
      onChange(name, selectedCustomersTmp);
    }
  };

  const handleClickClientListItem = (client) => {
    const currentCustomers = {
      ...selectedCustomers,
      [client.profileId]: { firstName: client.firstName, lastName: client.lastName },
    };

    setSelectedCustomers(currentCustomers);
    onChange(name, currentCustomers);
    setIsClientsSearchOpen(false);
  };

  const getChipsArray = () =>
    Object.entries(selectedCustomers).map(([profileId, data]) => {
      return {
        profileId,
        fullName: `${data.firstName} ${data.lastName}`,
      };
    });

  const chips = getChipsArray();

  return (
    <React.Fragment>
      <InputWithChips
        id="reminder-client"
        data-testid="reminder-client"
        labelPropertyName="fullName"
        value={chips}
        InputProps={{
          ...InputProps,
          placeholder: chips.length ? '' : 'Add Clients',
          inputRef,
        }}
        onDeleteChip={handleOnDeleteChips}
        hideDeleteChipButton={hideDeleteChipButton}
        onInputFocus={handleOnInputOpen}
      />
      <Drawer fullWidth open={isClientsSearchOpen}>
        <ClientSearchModalNew
          customClientClickAction={handleClickClientListItem}
          goBack={() => setIsClientsSearchOpen(false)}
          history={history}
          itemRenderer={ClientListItemGeneral}
          allowClickOnIcon
          withTabs
        />
      </Drawer>
    </React.Fragment>
  );
};

ClientListInput.propTypes = {
  classes: PropTypes.shape({}),
  customers: PropTypes.shape({}),
  name: PropTypes.string,
  onChange: PropTypes.func,
  hideDeleteChipButton: PropTypes.bool,
};

ClientListInput.defaultProps = {
  classes: {},
  customers: {},
  onChange: () => null,
  hideDeleteChipButton: false,
};

export default ClientListInput;
